/**
 * Returns the collection handle that should be used for an exclusive product for the given gender category.
 */
function exclusiveCollectionHandle(genderCategory: string): string {
  // unisex products might belong to both collections, but we need to choose one as the canonical collection
  // for now, choose the women's collection as customers are more likely to browse women's than men's collections
  // this should only matter for customers browsing from search (either internal or external)
  return genderCategory === 'men' ? 'atgt-mens' : 'atgt-womens'
}

type CreatePdpBaseUrlProps = {
  productGroupHandle: string
  collectionHandle: string | null | undefined
  isKit: boolean
  isExclusive: boolean | null | undefined
  genderKey: string | null | undefined
}

export const createPdpBaseUrl = (props: CreatePdpBaseUrlProps) => {
  const collectionPrefix = props.isKit
    ? ''
    : props.collectionHandle
    ? `/collections/${props.collectionHandle}`
    : props.isExclusive
    ? `/collections/${exclusiveCollectionHandle(props.genderKey ?? 'women')}`
    : ''

  return `${collectionPrefix}/${props.isKit ? 'kits' : 'products'}/${props.productGroupHandle}`
}

type CreatePdpUrlProps = CreatePdpBaseUrlProps & {
  colorKey: string | null | undefined
  fitKey: string | null | undefined
  sizeKey: string | null | undefined
  query?: Record<string, string | undefined>
}

/**
 * @deprecated use variantGroup.urlPath
 */
export const createPdpUrl = (props: CreatePdpUrlProps) => {
  const baseUrl = createPdpBaseUrl(props)

  const searchParams = new URLSearchParams()
  if (!props.isKit) {
    if (props.colorKey) {
      searchParams.set('color', props.colorKey)
    }
    if (props.fitKey) {
      searchParams.set('fit', props.fitKey)
    }
    if (props.sizeKey) {
      searchParams.set('size', props.sizeKey)
    }
  }
  if (props.query) {
    const query = props.query
    Object.keys(query).forEach(queryKey => {
      const queryValue = query[queryKey]
      if (queryValue) {
        searchParams.set(queryKey, queryValue)
      }
    })
  }
  const searchParamsString = searchParams.toString()

  return `${baseUrl}${searchParamsString.length > 0 ? '?' : ''}${searchParamsString}`
}
